import { render, staticRenderFns } from "./nativeMutiUpload.vue?vue&type=template&id=313c9e40&scoped=true"
import script from "./nativeMutiUpload.vue?vue&type=script&lang=js"
export * from "./nativeMutiUpload.vue?vue&type=script&lang=js"
import style0 from "./nativeMutiUpload.vue?vue&type=style&index=0&id=313c9e40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c9e40",
  null
  
)

export default component.exports